import { useQuery } from 'react-query'
import { useParams } from 'react-router-dom'
import { useEnvVars } from './useEnvVars'
import { useEffect } from 'react'
import { Shipment } from '../types/Shipment'

export const useGetShipment = () => {
  const { uuid } = useParams()
  const { env } = useEnvVars()

  const fetchShipment = async (): Promise<Shipment> => {
    const res = await fetch(
      `${env.QUIQUP_PLATFORM_URL}/shipments?client_order_id=${uuid}`
    )
    return res.json()
  }

  const shipmentQuery = useQuery(['shipments', uuid], fetchShipment)

  const { refetch: refetchShipment } = shipmentQuery

  useEffect(() => {
    if (uuid) {
      refetchShipment()
    }
  }, [uuid, refetchShipment])

  return shipmentQuery
}
